<svg width="41" height="36" viewBox="0 0 41 36" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_28159_46828)">
<path d="M24.828 11.0007H37V13.0007H24.828L30.192 18.3647L28.778 19.7787L21 12.0007L28.778 4.22266L30.192 5.63666L24.828 11.0007Z" fill="#09121F"/>
</g>
<g clip-path="url(#clip1_28159_46828)">
<path d="M16.172 23.0007L10.808 17.6367L12.222 16.2227L20 24.0007L12.222 31.7787L10.808 30.3647L16.172 25.0007H4V23.0007H16.172Z" fill="#09121F"/>
</g>
<defs>
<clipPath id="clip0_28159_46828">
<rect width="24" height="24" fill="white" transform="translate(17)"/>
</clipPath>
<clipPath id="clip1_28159_46828">
<rect width="24" height="24" fill="white" transform="translate(0 12)"/>
</clipPath>
</defs>
</svg>
